var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _this = this;
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { Hooks, IframeSelectors, JourneysSelectors, ResultsSelectors, useAppDispatch, useAppSelector, } from 'conversional-journey';
import { mapMessageToAction } from './utils/receiveMessage';
import getView from './utils/getView';
import { initializeWebSocket } from './utils/devConfigurationWatcherWebSocket';
import { useRpcListener } from './utils/listener';
/**
 * The root component defines the render View
 * Default iframe-communication, iframe styles and host event listeners are pre-configured by the view
 * The view ultimately decides which content is rendered and how it is displayed on the host
 // TODO: Add callbacks and window configuration styling somwhere
 */
var IframeRoot = function () {
    var dispatch = useAppDispatch();
    var viewProps = useAppSelector(IframeSelectors.selectIframeViewProps);
    var viewConfig = useAppSelector(IframeSelectors.selectIframeViewConfig);
    var iframeId = useAppSelector(IframeSelectors.currentIframeId);
    var resultId = useAppSelector(ResultsSelectors.currentResultId);
    var journeyId = useAppSelector(JourneysSelectors.currentJourneyId);
    var template = viewConfig.template, callbacks = viewConfig.callbacks, iframeStyles = viewConfig.iframeStyles;
    var handleKeyDownForSpaceToClick = function (e) {
        var target = e.target;
        if (!(target instanceof HTMLElement))
            return;
        var role = target.getAttribute('role');
        var isInteractive = role === 'button' || role === 'link';
        var isSpaceOrEnter = e.key === ' ' || e.key === 'Enter' || e.code === 'Space' || e.code === 'Enter';
        if (isInteractive && isSpaceOrEnter) {
            e.preventDefault();
            target.click();
        }
    };
    useEffect(function () {
        window.addEventListener('message', handleMessage);
        sendToHost.contentReady();
        document.addEventListener('keydown', handleKeyDownForSpaceToClick);
        if (process.env.REACT_APP_JOURNEY_ENV === 'development') {
            initializeWebSocket(dispatch);
        }
        return function () {
            window.removeEventListener('message', handleMessage);
            document.removeEventListener('keydown', handleKeyDownForSpaceToClick);
        };
    }, []);
    // Generic callbacks that can be triggered through the configuartion of every iframe
    var supportedCallbacks = {
        closeCallback: sendToHost.closeJourney,
    };
    Hooks.Callback.useCallbacks(_this, callbacks, supportedCallbacks);
    /**
     * Re-styles the iframe with the auto-extracted iframeStyles of the passed viewConfig
     * Function needs to be called manually from child components.
     * This ensures that iframe styles are only updated once the content is ready/available.
     */
    var onApplyStyles = function () {
        if (iframeStyles) {
            sendToHost.styleIframe(iframeStyles, false);
        }
    };
    var handleMessage = function (message) {
        var action = mapMessageToAction(message, { iframeId: iframeId, resultId: resultId, journeyId: journeyId });
        if (Array.isArray(action))
            return action.map(dispatch);
        return action && dispatch(action);
    };
    // Listen for rpc messages from the host for updating the Journney config
    useRpcListener(MESSAGETYPES.RPC_UPDATE_JOURNEY_CONFIGURATION_THEME);
    useRpcListener(MESSAGETYPES.RPC_UPDATE_JOURNEY_CONFIGURATION_CTA);
    useRpcListener(MESSAGETYPES.RPC_UPDATE_JOURNEY_CONFIGURATION_ENTRY);
    useRpcListener(MESSAGETYPES.RPC_DISABLE_EXIT_INTENT, function () {
        window.exitIntentDisabled = true;
    });
    useRpcListener(MESSAGETYPES.RPC_ENABLE_EXIT_INTENT, function () {
        window.exitIntentDisabled = false;
    });
    var View = getView(template);
    // @ts-ignore
    return _jsx(View, __assign({ onApplyStyles: onApplyStyles }, viewProps));
};
export default IframeRoot;
